module.exports = __webpack_public_path__ + "img/ntc.2a1b28b4.jpg";